import { render, staticRenderFns } from "./WalletRecharge.vue?vue&type=template&id=626a562c&scoped=true&"
import script from "./WalletRecharge.vue?vue&type=script&lang=js&"
export * from "./WalletRecharge.vue?vue&type=script&lang=js&"
import style0 from "./WalletRecharge.vue?vue&type=style&index=0&id=626a562c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a562c",
  null
  
)

export default component.exports